// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyB5rSBs0vhZW5-QApLQNPO3xFPc3hnOtDw",
    authDomain: "brfisheries-62f64.firebaseapp.com",
    databaseURL: "https://brfisheries-62f64.firebaseio.com",
    projectId: "brfisheries",
    storageBucket: "brfisheries.appspot.com",
    messagingSenderId: "925289322882",
    appId: "1:925289322882:web:bbcfb27b34088cc99d579b"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
